import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiSvgIcon(_theme: Theme): MuiThemeComponentOverride<"MuiSvgIcon"> {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&[data-rotation="-180"]': { transform: "rotate(-180deg)" },
          '&[data-rotation="-90"]': { transform: "rotate(-90deg)" },
          '&[data-rotation="180"]': { transform: "rotate(180deg)" },
          '&[data-rotation="90"]': { transform: "rotate(90deg)" },
          transition: "transform 0.25s ease-in-out",
          variants: [
            {
              props: { "data-variant": "page-header" },
              style: {
                // xs: 24px
                "@media (min-width: 576px)": {
                  // sm breakpoint
                  fontSize: "1.75rem", // sm: 28px
                },

                "@media (min-width: 768px)": {
                  // md breakpoint
                  fontSize: "2.25rem", // md: 36px
                },

                color: "#1380AA",
                // Color.BLUE[300].main - primary color
                fontSize: "1.5rem",
              },
            },
          ],
        },
      },
    },
  };
}
